// TIMEREG. Helpers
import { SelectOption } from '@ssg/common/Helpers/Helpers';

// Helper Functions / ressources

export const activityCode: SelectOption[] = [
	{ label: 'Intern', value: 'INTERN' },
	{ label: 'Køreseddel', value: 'DRIVINGSLIP' },
	{ label: 'Sag', value: 'CASE' },
];

// SALARY TYPES
export const sanitoer = ['20700', '20970'];

export const industrimedarbejder = ['10000', '100002', '20900'];

export const funktionaer = ['88985', 'Funk'];

export const tomroerSnedker = ['02100', '02300', '06110', '06160'];

export const vagtcentral = ['VAGT'];

// SUPPLEMENTS FILTERING
// Auto. supplements will be hidden from supplement options
export const automaticSupplements = [
	'2100', // Overtid 1
	'2101', // Overtid 2
	'2105', // Overtid (INTERN)
	'8599', // Overtid (INTERN)
	'2051', // Aften
	'2052', // Aften (INTERN)
	'2054', // Nat
	'2055', // Nat (INTERN)
	'2095', // Lørdag
	'2056', // Søndag
	'2057', // Søndag (INTERN)
];

export const automaticSupplementsFunk = [
	'2101', // Overtid 2
	'2051', // Aften
	'2052', // Aften (INTERN)
	'2054', // Nat
	'2055', // Nat (INTERN)
	'2056', // Søndag
	'2057', // Søndag (INTERN)
];

// Only one of these is allowed to be added per. day
export const shiftSupplements = [
	'2092', // Bagvagttillæg hverdag VC
	'2093', // Bagvagttillæg weekend VC
	'2094', // Vagttillæg Vagtmand (Sanitør)
	'2150', // Vagttillæg Vagtleder
];

export const pieceworkSupplements = [
	'8401', // Akkord (Timer)
	'8402', // Akkord (Beløb)
];

// List of allowed supps for sanitarians (Sanitør)
export const sanitoerSupplements = [
	'2180', // Asbest
	'8010', // Kørselstid
	'8011', // Kørselstid (INTERN)
	'8004', // kørte km i egen vogn
	'2190', // Særligt
	'2094', // Vagttillæg Vagtmand (Sanitør)
	'2150', // Vagttillæg Vagtleder
	'2170', // Beregnet tillæg
	'2171', // Beregnet tillæg (INTERN)
	'8600', // Afvarsling
	'8640', // Udkald tillæg
	'8401', // Akkord (Timer)
	'8402', // Akkord (Beløb)
];

// List of allowed supps for industrial workers (Industrimedarbejder)
export const industrimedarbejderSupplements = [
	'2180', // Asbest
	'2197', // Gene
	'8010', // Kørselstid
	'8011', // Kørselstid (INTERN)
	'8004', // kørte km i egen vogn
	'2198', // Skadeservice
	// '2190', // Særligt
	'2094', // Vagttillæg Vagtmand (Sanitør)
	'2150', // Vagttillæg Vagtleder
	'2170', // Beregnet tillæg
	'2171', // Beregnet tillæg (INTERN)
	'8610', // Hovedrengøring
	'8620', // Skur tillæg
	'8630', // Varsko tillæg
	'8640', // Udkald tillæg
	'8401', // Akkord (Timer)
	'8402', // Akkord (Beløb)
];

// List of allowed supps for white-collar workers (Funktionær)
export const funktionaerSupplements = [
	'2100', // Overtid 1 supplement
	'2105', // Overtid (INTERN)
	'8004', // kørte km i egen vogn
	'2094', // Vagttillæg Vagtmand (Sanitør)
	'2150', // Vagttillæg Vagtleder
];

// List of allowed supps for carpenter, carpenter apprentice and painter (Tømrer / snedker)
export const tomroerSnedkerSupplements = [
	'8004', // kørte km i egen vogn
	'2195', // Smuds
	'2094', // Vagttillæg Vagtmand (Sanitør)
	'2150', // Vagttillæg Vagtleder
	'2170', // Beregnet tillæg
	'2171', // Beregnet tillæg (INTERN)
	// '8401', // Akkord (Timer)
	// '8402', // Akkord (Beløb)
];

// Should only be available for dispatch workers (Vagtcentral)
export const vagtcentralSupplements = [
	'8004', // kørte km i egen vogn
	'2100', // Overtid 1 supplement
	'2105', // Overtid (INTERN)
	// '2171', // Beregnet tillæg (INTERN)
	'2092', // Bagvagttillæg hverdag VC
	'2093', // Bagvagttillæg weekend VC
];

// JOBTASK FILTERING
// Should be only available options for ranged dates
export const rangedJobTasks = [
	'002', // Syg
	'004', // Fri for egen regning
	'005', // Barsel
	'007', // Feriefridag
	'008', // Feriedag
	'013', // Fravær pga. arbejdsskade.
	// '015', // Fravær pga. COVID-19 // BEL-747
	// '017', // Hjemsendelse // BEL-747
	'021', // Skole ophold - IT student
	'022', // Syg - Langtidssydom
	'0034', // §56 sygdom
];

// Round to the nearest 0.25
export function roundToNearestQuarter(hour: number): number {
	return Math.round(hour * 4) / 4;
}

export function calculateHours(startStr: string | undefined, endStr: string | undefined): number {
	if (typeof startStr === 'undefined' || typeof endStr === 'undefined') {
		return 0;
	}
	const [startTime, startDate] = startStr.split('D');
	const [endTime, endDate] = endStr.split('D');
	const [startHour, startMinute] = startTime.split(':').map(Number);
	const [endHour, endMinute] = endTime.split(':').map(Number);

	const startTimeHours = startHour + startMinute / 60;
	const endTimeHours = endHour + endMinute / 60;

	let hoursDiff = endTimeHours - startTimeHours;

	// Handling cases where the end time is before the start time (e.g., overnight shifts)
	if (startDate !== endDate) {
		hoursDiff += 24; // 24-hour day
	}

	return hoursDiff;
}

// Checks if the time is within the lunch time range
export function isWithinLunchTimeRange(startTime: string, endTime: string): boolean {
	const lunchStart = '11:00';
	const lunchEnd = '13:00';

	// Check if the startTime or endTime is within the lunch time range
	const startWithinLunch = startTime <= lunchEnd && startTime >= lunchStart;
	const endWithinLunch = endTime >= lunchStart && endTime <= lunchEnd;

	// Check if the range overlaps with the lunch time range
	const rangeCoversLunch = startTime <= lunchStart && endTime >= lunchEnd;

	return startWithinLunch || endWithinLunch || rangeCoversLunch;
}

export const addMinutesToTime = (timeStr: string, minutesToAdd: number) => {
	if (typeof timeStr === 'undefined') return;
	// Split the time string into hours and minutes
	const [hours, minutes] = timeStr.split(':').map(Number);

	// Create a new Date object with the current date
	const date = new Date();
	date.setHours(hours);
	date.setMinutes(minutes);

	// Add the specified number of minutes
	date.setMinutes(date.getMinutes() + minutesToAdd);

	// Extract the new hours and minutes
	const newHours = date.getHours();
	const newMinutes = date.getMinutes();

	// Format the new time as 'HH :MM'
	const formattedHours = String(newHours).padStart(2, '0');
	const formattedMinutes = String(newMinutes).padStart(2, '0');

	return `${formattedHours}:${formattedMinutes}`;
};